import React, { useEffect, useState } from 'react';
import { Link } from '../router';
import { getConsent, loadAnalytics, saveConsent, Consent } from '../consent';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (consent === 'granted') loadAnalytics();
    setVisible(consent === null);
  }, []);

  const choose = (value: Consent) => {
    saveConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="region" aria-label="Cookie consent">
      <p>
        I use Google Analytics cookies to see which content helps people most. Nothing is shared for advertising.{' '}
        <Link to="/privacy">Privacy Policy</Link>
      </p>
      <div className="cookie-banner__buttons">
        <button className="btn btn-primary" onClick={() => choose('granted')}>
          Accept
        </button>
        <button className="cookie-banner__decline" onClick={() => choose('denied')}>
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
